module.exports = __webpack_public_path__ + "static/media/ImgMBTI_ROTC.b7dd7c6b.png";